// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__GNo9G","featuredImage":"style_featuredImage__P_HeP","featuredText":"style_featuredText__1SNew","articleTitle":"style_articleTitle__ZjswP"};